import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getComingSoonPageData = async () => {
  const data = await fetchData(ENDPOINTS.GET.COMING_SOON, {
    method: METHODS.GET,
  });
  return data;
};
